(function() {
  document.addEventListener("DOMContentLoaded", () => {
    // Save and autofill registration information
    let sessionStorage = window.sessionStorage,
      account_info = {},
      form = document.getElementById('create_customer'),
      first_name = form.querySelector('[name="customer[first_name]"]'),
      last_name = form.querySelector('[name="customer[last_name]"]'),
      birthday_year = form.querySelector('[name="customer[note][birthday year]"]'),
      birthday_month = form.querySelector('[name="customer[note][birthday month]"]'),
      birthday_day = form.querySelector('[name="customer[note][birthday day]"]'),
      // wedding_month = form.querySelector('[name="customer[note][wedding month]"]'),
      // wedding_day = form.querySelector('[name="customer[note][wedding day]"]'),
      // wedding_year = form.querySelector('[name="customer[note][wedding year]"]'),
      email = form.querySelector('[name="customer[email]"]'),
      phone = form.querySelector('[name="customer[note][phone]"]'),
      address1 = form.querySelector('[name="customer[note][address1]"]'),
      address2 = form.querySelector('[name="customer[note][address2]"]'),
      city = form.querySelector('[name="customer[note][city]"]'),
      state = form.querySelector('[name="customer[note][state]"]'),
      zip = form.querySelector('[name="customer[note][zip]"]'),
      pronoun = form.querySelector('[name="customer[note][pronoun]"]'),
      gift = form.querySelector('[name="customer[note][gift]"]'),
      newsletter = form.querySelector('[name="customer[accepts_marketing]"]'),
      //  sms = form.querySelector('[name="customer[note][sms_marketing]"]'),
      password = form.querySelector('[name="customer[password]"]'),
      submitBtn = form.querySelector('button[type="submit"]');

    var required_fields = [first_name, last_name, email, zip, password];

    if (sessionStorage.getItem('account_info')) {
      let account_info = JSON.parse(sessionStorage.getItem('account_info'));
      first_name.value = account_info.first_name;
      last_name.value = account_info.last_name;
      birthday_year.value = account_info.birthday_year;
      birthday_month.value = account_info.birthday_month;
      birthday_day.value = account_info.birthday_day;
      // wedding_month.value = account_info.wedding_month;
      // wedding_day.value = account_info.wedding_day;
      // wedding_year.value = account_info.wedding_year;
      email.value = account_info.email;
      phone.value = account_info.phone;
      address1.value = account_info.address1;
      address2.value = account_info.address2;
      city.value = account_info.city;
      state.value = account_info.state;
      zip.value = account_info.zip;
      pronoun.value = account_info.pronoun;
      gift.value = account_info.gift;
      //  sms.checked = account_info.sms;
      newsletter.checked = account_info.newsletter;
    }

    submitBtn.addEventListener('click', (e) => {
      e.preventDefault();

      let zip_code = zip.value;
      let zip_is_digits = /^\d+$/.test(zip_code);
      let zip_is_five = zip_code.length === 5;
      let required_fields_filled = true;

      for (let i = 0, limit = required_fields.length; i < limit; i ++) {
        if (required_fields[i].value.length === 0) {
          required_fields_filled = false;
        }
      }
      
      if (!zip_is_digits || !zip_is_five) {
        required_fields_filled = false;
      }

      if (!email.value.includes('@')) {
        required_fields_filled = false;
      }

      if (first_name.value === last_name.value) {
        required_fields_filled = false;
        alert('Your form entries seem incorrect. Please double-check what you entered. If this error persists, contact us through via live chat or via email at contact-us@hankypanky.com.');
    }

      if (required_fields_filled) {
        account_info.first_name = first_name.value;
        account_info.last_name = last_name.value;
        account_info.birthday_year = birthday_year.value;
        account_info.birthday_month = birthday_month.value;
        account_info.birthday_day = birthday_day.value;
        // account_info.wedding_month = wedding_month.value;
        // account_info.wedding_day = wedding_day.value;
        // account_info.wedding_year = wedding_year.value;
        account_info.email = email.value;
        account_info.phone = phone.value;
        account_info.address1 = address1.value;
        account_info.address2 = address2.value;
        account_info.city = city.value;
        account_info.state = state.value;
        account_info.zip = zip.value;
        account_info.pronoun = pronoun.value;
        account_info.gift = gift.value;
        //  account_info.sms = sms.checked;
        account_info.newsletter = newsletter.checked;
        sessionStorage.setItem('account_info', JSON.stringify(account_info));

        var submit_form = form.cloneNode(true);

        submit_form.querySelector('[name="customer[note][birthday year]"]').value = birthday_year.value;
        submit_form.querySelector('[name="customer[note][birthday month]"]').value = birthday_month.value;
        submit_form.querySelector('[name="customer[note][birthday day]"]').value = birthday_day.value;
        submit_form.querySelector('[name="customer[note][state]"]').value = state.value;
        submit_form.querySelector('[name="customer[note][pronoun]"]').value = pronoun.value;
        submit_form.querySelector('[name="customer[note][gift]"]').value = gift.value;

        // Post data using the Fetch API
        fetch(submit_form.action, {
          method: submit_form.method,
          body: new FormData(submit_form),
          redirect: 'manual',
        })
        .then((response) => {
          if (response.type === 'opaqueredirect') {
            // Handle the redirect manually
            window.location.href = response.url;
            return;
          }
          if (!response.ok) {
            alert('Something has gone wrong, please try reloading the page and submitting the form again, or contact us through via live chat or via email at contact-us@hankypanky.com');
            throw Error(response.status);
          }
          return response.text();
        })
        .then((data) => {
          console.log(data);
          window.location.href = window.Shopify.routes.root + 'account';
        })
        .catch((error) => {
          console.error('Error:', error);
        });
      } else {
        alert('Please enter information for all the required form fields');
      }
    });
    

    // return_url attrribute for registration form
    if (window.location.href.includes('return_url')) {
      let return_to = document.querySelector('input[name="return_to"]');
      return_to.value = window.location.href.slice((window.location.href.indexOf('return_url=') + 11)).replaceAll('%2F','/');
    }

    // Wedding date validation
    // let today = new Date();
    // let year_options = wedding_year.querySelectorAll('option');
    // let selects = document.querySelectorAll('.js-register-wedding-date select');

    // var attributes = [];
    // selects.forEach((element, index) => {
    //   attributes.push(element.getAttribute('name'));
    //   element.setAttribute('name', 'null');
    // });

    // // Build year options from 4 years into the future to 1940
    // let this_year = today.getFullYear();
    // let years = this_year - 1940 + 4;
    // let new_years = document.createDocumentFragment();

    // new_years.appendChild(document.createElement('option'));

    // for (let i = 0; i <= years; i++) {
    //   let option = document.createElement('option');
    //   option.textContent = this_year - i + 4;
    //   new_years.appendChild(option);
    // }

    // wedding_year.innerHTML = '';
    // wedding_year.appendChild(new_years);

    // Only allow future wedding dates script removed
    // if (this_year > parseInt(year_options[1].textContent)) {
    //   let new_years = document.createDocumentFragment();
    //   let option = document.createElement('option');

    //   new_years.appendChild(option);

    //   for (let i = 0; i < 10; i++) {
    //     let option = document.createElement('option');
    //     option.textContent = this_year + i;
    //     new_years.appendChild(option);
    //   }

    //   wedding_year.innerHTML = '';
    //   wedding_year.appendChild(new_years);
    // }

    // let validateWeddingDate = function() {
    //   let date_wedding_day = wedding_day.value;
    //   let name_wedding_month = wedding_month.value;
    //   let date_wedding_year = wedding_year.value;
    //   let date_wedding_month = new Date(Date.parse(name_wedding_month +" 1, 2020")).getMonth()+1;
      
    //   if (date_wedding_day === '' || date_wedding_month === '' || date_wedding_year === '') {
    //     document.querySelector('.js-register-wedding-error').classList.add('hidden');
    //     console.log('Wedding date is incomplete');
    //   } else if (Date.UTC(today.getFullYear(), (today.getMonth() + 1), today.getDate()) > Date.UTC(date_wedding_year, date_wedding_month, date_wedding_day)) {
    //     wedding_year.value = today.getFullYear() + 1;
    //     document.querySelector('.js-register-wedding-error').classList.remove('hidden');
    //     console.log('Please enter a data in the future');
    //   } else {
    //     document.querySelector('.js-register-wedding-error').classList.add('hidden');
    //     selects.forEach((element, index) => {
    //       element.setAttribute('name', attributes[index]);
    //     });
    //     console.log('Wedding date is in the future');
    //   }
    // };

    // wedding_day.addEventListener('change', validateWeddingDate);
    // wedding_month.addEventListener('change', validateWeddingDate);
    // wedding_year.addEventListener('change', validateWeddingDate);
  });
})();